import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const CRMStatCard = ({ label, value, sub, accent = "#111827", icon }) => {
    return (
        <Card
            elevation={0}
            sx={{
                flex: 1,
                minWidth: 140,
                background: "rgba(255,255,255,0.6)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                border: "1px solid rgba(255,255,255,0.8)",
                borderRadius: 2,
                boxShadow: "0 8px 32px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
                "&:hover": {
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.1)",
                },
            }}
        >
            <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: 1.4,
                            color: "text.secondary",
                        }}
                    >
                        {label}
                    </Typography>
                    {icon && (
                        <Box
                            sx={{
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                display: "grid",
                                placeItems: "center",
                                color: accent,
                                backgroundColor: alpha(accent, 0.12),
                            }}
                        >
                            {icon}
                        </Box>
                    )}
                </Box>
                <Typography
                    variant="h5"
                    sx={{ fontWeight: 800, color: accent, letterSpacing: "-0.02em", lineHeight: 1 }}
                >
                    {value}
                </Typography>
                {sub && (
                    <Typography variant="caption" sx={{ color: "text.secondary", mt: 0.75, display: "block" }}>
                        {sub}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default CRMStatCard;
